module.exports = __webpack_public_path__ + "static/img/back.4e76c8e6.png";